import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

export const useAccountId = (): AccountId | null => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.atlassianAccountId) || null;
};
